<template>
  <div class="test">
    <img src="../assets/中金logo.png" alt="" style="display:block;margin:0 auto 10px">
    <div class="detail">
      产品名称：{{info.productName}}
    </div>
    <div class="detail">
      产品质量：{{info.quality}}克
    </div>
    <div class="detail">
      条码：{{info.barCode}}
    </div>
    <div class="detail" v-if="printtype == 17 || printtype == 18 ||printtype == 19 ||printtype == 20">
      主石：{{info.mainStoneName}}
    </div>
    <div class="detail" v-if="printtype == 17 ||printtype == 18 || printtype == 19 ||printtype == 20">
      主石重量：{{info.mainStone}}
    </div>
    <div class="detail" v-if="printtype == 17 ||printtype == 18 ||printtype == 19 ||printtype == 20">
      主石净度：{{info.purity}}
    </div>
    <div class="detail" v-if="printtype == 17 ||printtype == 18 ||printtype == 19 ||printtype == 20">
      主石颜色：{{info.color}}
    </div>

    <div class="detail">
      证书编号：{{info.certificateNumber}}
    </div>
    <div class="detail" v-if="printtype==31 || printtype==32 || printtype==33 || printtype==34 || printtype==35 || printtype==36 || printtype==37 || printtype==38 || printtype==39 || printtype==40">
      银含量：{{info.goldContent}}
    </div>
    <div class="detail" v-if="printtype==12 ||printtype==13 || printtype==14 || printtype==15 || printtype==16">
      尺寸：{{info.size}}
    </div>
    <div class="detail" v-if="printtype!=2 && printtype!=3 && printtype!=4 && printtype!=5 && printtype!=6 &&printtype!=11 &&printtype!=17 &&printtype!=18 &&printtype!=19 &&printtype != 20&&printtype != 21&&printtype != 22&&printtype != 23&&printtype != 24&&printtype != 25&&printtype != 26&&printtype != 27&&printtype != 28&&printtype != 29&&printtype != 30&&printtype != 31&&printtype != 32&&printtype != 33&&printtype != 34&&printtype != 35&&printtype != 36&&printtype != 37&&printtype != 38&&printtype != 39&&printtype != 40">
      <div v-if="info.goldContent">
        金含量：{{info.goldContent}}‰
      </div>
    </div>
    <div class="detail" v-if="printtype!=12 &&printtype!=13 && printtype!=14 && printtype!=15 && printtype!=16 &&printtype!=17 &&printtype!=18 &&printtype!=19 &&printtype != 20&&printtype != 21&&printtype != 22&&printtype != 23&&printtype != 24&&printtype != 25&&printtype != 26&&printtype != 27&&printtype != 28&&printtype != 29&&printtype !=30&&printtype != 31 &&printtype != 32&&printtype != 33&&printtype != 34&&printtype != 35&&printtype != 36&&printtype != 37&&printtype != 38&&printtype != 39&&printtype != 40">
      <div v-if="info.checkCode">
        校验码：{{info.checkCode}}
      </div>
    </div>
    <div class="detail"  v-if="printtype!=12 &&printtype!=13 && printtype!=14 && printtype!=15 && printtype!=16 &&printtype!=17 &&printtype!=18 &&printtype!=19 &&printtype != 20&&printtype != 31 &&printtype != 32&&printtype != 33&&printtype != 34&&printtype != 35&&printtype != 36&&printtype != 37&&printtype != 38&&printtype != 39&&printtype != 40">
      备注：{{info.remark}}
    </div>
    <div class="detail">
      公司名称：{{info.companyName}}
    </div>
    <div class="detail">
      公司地址：{{info.companyAdress}}
    </div>
    <div class="detail">
      客服电话：{{info.customerServicePhone}}
    </div>
    <div class="detail">
      公司网址：{{info.companyUrl}}
    </div>
    <div class="detail">
      检测机构：{{info.testingCenterName}}
    </div>
    <div class="detail">
      <i @click="href1(1)" style="font-style: normal;color:#337ab7;">检测网址：http://{{info.testCenterInter}}</i> 
    </div>
    <div class="detail">
      电话：{{info.telephone}}
    </div>
    <div class="detail">
      <img src="" alt="" id="barcode" style="width:200px;height:50px">
      <div class="barcode">{{info.barCode}}</div>
    </div>
    <div class="detail" style="margin-top: 10px;">
      <i  @click="href1(2)" style="font-style: normal;color:#337ab7;">https://www.chnau99999.com/web/Emoji.html</i> 
    </div>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode'
export default {
  name: 'test',
  data () {
    return {
      id:'',
      info:{},
      printtype:'',
      barCode:'',
    }
  },
  
  created() {
  
    console.log(window.location.href);
      var query =this.$route.query;
      this.id = query.id;
      this.printtype = query.printtype
      console.log(query);
      if(this.id != ''){
        this.getInfo()
      }

  },
  mounted(){
    console.log(this.info);
    //  JsBarcode('#barcode', this.info.barCode, {
    //   format: 'CODE39',
    //   lineColor: '#000',
    //   background: '#EBEEF5',
    //   width: 2,
    //   height: 40,
    //   displayValue: false
    // })
  },
  methods:{
//接口调用
    async getInfo(){
      let data = {
        id: this.id
      }
      console.log(data);
        const res = await this.$http.getInfo(this.id)
      this.info = res.data.data
      console.log(this.info);
      JsBarcode('#barcode', this.info.barCode, {
      format: 'CODE39',
      lineColor: '#000',
      background: '#fff',
      width: 2,
      height: 40,
      displayValue: false
    })
    },
     getUrlStr(){
        
     },
    href1(index) {
      let href 
      if(index == 1) {
          href ='http://'+this.info.testCenterInter
      }else if(index == 2) {
        href ='https://www.chnau99999.com/web/Emoji.html'
      }
      window.open(href, '_blank');
    }
  },

}
</script>


<style scoped>
  .test {
    margin-top: 10px;
  }
  .detail {
    display: block;
    width: 87%;
    font-size: 14px;
    color: #333;
    margin:0 auto 2px;
    word-wrap:break-word;
    font-family: '微软雅黑 Regular','微软雅黑';
  }
  .barcode {
    margin-top: -10px;
    width:200px;
    text-align: center;
    font-size: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/test.vue